import {styled} from '../theme-provider';

export const AutoCompleteContainer = styled.input``;
